import React from 'react';
import Header from './Header';
import Footer from './Footer';
import LandingAnim from './LandingAnim';
import NavBar from './NavBar';
import { useMediaQuery } from 'react-responsive';


const Layout = ({ children }) => {
const isMobile = useMediaQuery({ query: '(max-width: 456px)' });
  if (isMobile) {
    return (
      <div className="App">
        <div id="title"></div>
        <NavBar />
        <LandingAnim />
        {children}
        <Footer />
      </div>
    );
  } else 
  {
  return (
    <div className="App">
      <div id="title"></div>
      <Header />
      <LandingAnim /> 
       <NavBar />
      {children}
      <Footer />
    </div>
  );
}
};

export default Layout;
